<nav-bar [titulo]="'Core'" [iconeNotificacoes]="false" [botaoMenu]="true" (logoutEvent)="logout($event)"
    [linkPainelAplicacoes]="URL_LOGIN"></nav-bar>
<menu-lateral [itensMenu]="menuItens">
    <copyright></copyright>
</menu-lateral>